export enum CoreClientContactApiTags {
  ClientContactList = 'ClientContactList',
}

export const coreClientContactApiTagTypes = Object.values(CoreClientContactApiTags);
